// Shared between the announcement color picker (create/edit forms) and the
// ribbon that renders on ProductCard/ProductDetail - keeps "what an
// announcement looks like when nobody has picked colors yet" in one place.
export const DEFAULT_ANNOUNCEMENT_BACKGROUND = "#dc2626"; // tailwind red-600
export const DEFAULT_ANNOUNCEMENT_TEXT = "#ffffff";